module.exports = __webpack_public_path__ + "static/img/UY.9f31b5ce.jpg";